<template>
  <div class="sj-link-menu-item">
    <!-- <div class="sj-link-menu-item-title">{{label}}</div> -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SjLinkMenuItem",
  props: {
    label: {
      type: String,
      required: true
    },
    labelRenderer: {
      type: Function
    }
  }
};
</script>

<style lang="less" scoped>
.sj-link-menu-item {
  display: flex;
  flex-direction: column;
  background-color: @linkmenu-content-item-background-color;
  box-shadow: 0 4px 8px 0 rgba(144, 164, 183, 0.22);

  .sj-link-menu-item-title {
    .text("caption", "available");
  }
}
</style>
